import { TextWordLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useExportAsDoc } from '@/hooks'
import { selectIsLoading } from '@/store'
import { ExportItem } from '../ExportItem'

interface Props {
  exportable: boolean
}

export const ExportDoc: React.FC<Props> = ({ exportable }) => {
  const txtLoading = useSelector(selectIsLoading('export_doc'))

  const onClick = useExportAsDoc()

  return (
    <ExportItem
      label="Word"
      exportable={exportable}
      loading={txtLoading}
      icon={TextWordLight}
      onClick={onClick}
    />
  )
}
